export enum GlobalLayout {
  Centered = 'centered',
  TwoColumns = 'two-columns',
}
